<template>
  <div>
    <h3 class="mb-4">
      <strong>Purchase Summary</strong>
    </h3>

    <b-list-group>
      <b-list-group-item>
        Voucher Details:
        <ul>
          <li>Value: {{ styleStore.storeInfo.currency }}{{ formStore.formData.voucherValue }}</li>
          <li>Quantity: {{ formStore.formData.quantity }}</li>
        </ul>
      </b-list-group-item>

      <b-list-group-item>
        {{ formStore.formData.quantity }} x {{ styleStore.storeInfo?.name }} Voucher
        <span class="float-right">{{ styleStore.storeInfo.currency }}{{
          formStore.formData.voucherValue * formStore.formData.quantity
        }}</span>
      </b-list-group-item>
      <b-list-group-item>
        Processing Fee
        <span class="float-right">{{ styleStore.storeInfo.currency }}{{ formStore.formData.processingFee.toFixed(2) }}</span>
      </b-list-group-item>
      <b-list-group-item v-if="formStore.formData.deliveryMethod === 'postal'">
        Postal Fee
        <span class="float-right">{{ styleStore.storeInfo.currency }}{{ formStore.formData.postalFee * formStore.formData.quantity }}</span>
      </b-list-group-item>
      <b-list-group-item v-if="formStore.formData.discountApplied">
        Discount
        <span class="float-right">-{{ styleStore.storeInfo.currency }}{{ formStore.formData.discountAmount }}</span>
      </b-list-group-item>
      <b-list-group-item class="font-weight-bold">
        Total
        <span class="float-right">{{ styleStore.storeInfo.currency }}{{ formStore.totalAmount }}</span>
      </b-list-group-item>
    </b-list-group>
    <!-- <h3 class="mt-4 mb-4">
      <strong>Discount Code</strong>
    </h3>
    <b-input-group>
      <b-form-input
        v-model="formStore.formData.discountCode"
        placeholder="Discount Code"
      />
      <b-input-group-append class="ms-3">
        <b-button
          class="ms-3"
          variant="outline-secondary"
          @click="formStore.applyDiscount"
        >
          Apply Discount
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <small
      v-if="formStore.formData.discountApplied"
      class="text-success"
    >Discount applied successfully!</small> -->
    <div class="mt-4">
      <b-form-checkbox v-model="formStore.formData.acceptTerms">
        I accept the terms and conditions of sale
      </b-form-checkbox>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <b-button
        variant="light"
        @click="formStore.prevStep"
      >
        BACK
      </b-button>
      <b-button
        v-if="styleStore.storeInfo.has_active_connected_account"
        variant="primary"
        :disabled="formStore.loading || isProcessing"
        @click="handleComplete"
      >
        <b-spinner
          v-if="formStore.loading"
          small
          class="mr-2"
        />
        Complete Purchase
      </b-button>
    </div>

    <h3 class="mt-4 mb-4">
      <strong>Terms and Conditions</strong>
    </h3>
    <p>
      1. You must present the gift voucher in the establishment upon arrival. 
      2. Gift Vouchers cannot be extended, are non-transferable and non-refundable.       
      3. Your voucher code is unique to you, it is your responsibility to not disclose this code to others. 
      4. Gift Vouchers are valid from the date of purchase until the expiry date.
      <span v-if="storeEmail === 'leanne@thedoughbros.ie'">
        5. Vouchers not redeemable in Dough Bros(middle street)
      </span>
    </p>

    <!-- <div class="payment-methods mt-4">
      <b-button
        variant="outline-primary"
        class="mr-2"
        @click="selectPayment('visa')"
      >
        VISA
      </b-button>
      <b-button
        variant="outline-primary"
        class="mr-2"
        @click="selectPayment('mastercard')"
      >
        MasterCard
      </b-button>
      <b-button 
        variant="outline-primary"
        @click="selectPayment('applepay')"
      >
        Apple Pay
      </b-button>
    </div> -->
  </div>
</template>

<script>
import { useFormStore } from "../stores/formStore";
import { useStyleStore } from "../stores/styleStore";
import Swal from 'sweetalert2';
export default {
  components: {},
  emits: ["complete"],
  data() {
    return {
      showWarning: false,
      warningMessage: '',
      formStore: useFormStore(),
      styleStore: useStyleStore(),
      isProcessing: false,

    };
  },
  computed:{
    storeEmail() {
    return this.styleStore.storeInfo?.email?.trim() || "";
  }
  },
  mounted() {
    // console.log(
    //   "Step5Summary mounted with data:",
    //   JSON.stringify(this.formStore.formData, null, 2)
    // );
  },
  methods: {
    async handleComplete() {
      if (!this.formStore.formData.acceptTerms) {
        Swal.fire({
          icon: 'warning',
          title: 'Please accept the Terms and Conditions to proceed.',
        });
        return;
      }

      try {
      this.isProcessing = true;  // Set flag before async call
        // await this.formStore.completePurchase();
        this.$emit("complete");
      } catch (error) {
        this.warningMessage = 'Purchase failed. Please try again later.';
        this.showWarning = true;
      }
      finally {
       this.isProcessing = false;  // Reset flag after completion
     }
    },
    selectPayment(method) {
      this.formStore.updateFormData({ paymentMethod: method });
    },
  },
};
</script>

<style scoped>
.float-right {
  float: right;
}

.payment-methods {
  display: flex;
  justify-content: center;
}
</style>
